import { Button, Col, Flex, Modal, Row } from "antd"
import { spacings } from "themes/variables"
import { useState } from "react"
import { useNavigate } from "react-router-dom"
import UploadFile from "../ImportClientList/UploadFile"
import style from "./failedClientList.module.css"
import { Cancel } from "ui/Icon/DSIcon/Cancel"
const FailedImportReport = () => {

  const failedClients = [
    { id: "023", name: "Esther Howard", error: "Invalid email format" },
    { id: "124", name: "Kathryn Murphy", error: "Missing phone number and email" }
  ]
  const [isFailedClientModalVisible, setIsFailedClientModalVisible] = useState(true)
  const navigate = useNavigate()

  const handleCloseModal = () => {
    setIsFailedClientModalVisible(!isFailedClientModalVisible)
    navigate(-1)
  }

  return (
    <Modal
      title="Failed Import Report"
      open={isFailedClientModalVisible}
      onCancel={handleCloseModal}
      footer={null}
      width={{ xxl: 626 }}
      height={"500px"}
    >
      <div>Data of {failedClients.length} clients failed to upload:</div>
      <Flex vertical gap="small" className={style.container}>
        {failedClients?.map((client) => (
          <Row key={client?.id} className={style.rowBorder} justify="space-between">
            <Col style={{ width: 40 }}>{client?.id}</Col>
            <Col style={{ width: 200 }}>{client?.name}</Col>
            <Col className={style.errorCol} style={{ width: 300 }}>
              <Cancel fill="#F76659" />
              {client?.error}
            </Col>
          </Row>
        ))}
      </Flex>

      <div className="mb-m" style={{ marginTop: "20px" }}>
        Please check each client has a name, and that the email or phone associated is in the correct format and try again.
      </div>

      <UploadFile />

      <Flex className="save-wrapper" justify="flex-start" gap={spacings.S} style={{ marginTop: "86px" }}>
        <Button className="pr-xl pl-xl" color="primary" variant="outlined" size="large" onClick={handleCloseModal}>
          Close
        </Button>
        <Button className="pr-xl pl-xl" color="primary" variant="solid" size="large">
          Retry
        </Button>
      </Flex>
    </Modal>
  )
}

export default FailedImportReport
